import { runAction } from "../client";

export interface TagsResult
{
    Tags: string[];
}

export interface GetVehicleTagsFn
{
    (): Promise<TagsResult>;
}

export const getVehicleTags: GetVehicleTagsFn = () => {
    return runAction<TagsResult>('/action/GetAllVehicleTags', {});
}


// WEBPACK FOOTER //
// ./src/rest/Misc/vehicle-tags.ts